module.exports = __webpack_public_path__ + "img/powered-by-light.b2f49fb3.svg";